import React, {useContext} from "react";
import {Typography, Space, Title} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";
// forms
import ExtendForm from "../../forms/extend";
// core
import {LayoutContext} from "../../../core/Contexts";
import exkl from "../../../images/error@2x.png";

export default React.memo(
    observer(function NotVerificationModal() {
        const contextLayout = useContext(LayoutContext);
        const {t} = useTranslation();

        return (
            <Typography as="div" className="bl-not-verification-modal">
                <Typography as="div">
                    <Space size={16} direction="vertical" align="center">
                        <img
                            src={exkl}
                            width={_.gte(contextLayout?.width, 431) ? 130 : 78}
                            alt=""
                        />
                        <Title>
                            {
                                "Будет доступно после подписания договора и выдачи доверенности представителя компании."
                            }
                        </Title>
                        <Typography
                            as="div"
                            color="#fff"
                            size={_.gte(contextLayout?.width, 431) ? 17 : 13}
                            className="subtitle"
                        >
                            {t(`Верификация доступна в мобильном приложении  `)}
                            <br />
                            <Typography as="span" size={19} color="#fff">
                                {t(` Store Безлимит`)}
                            </Typography>
                        </Typography>
                    </Space>
                </Typography>
            </Typography>
        );
    })
);
